import { dataLock } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLock = /*#__PURE__*/createIcon(dataLock)
export default IconLock
